/** @format */

import React, { useState, useContext, useEffect } from "react";
import UserContext from "../../context/Globales/UserContext";
import { useHistory } from "react-router-dom";
import NumberFormat from "react-number-format";
import {
  TextField,
  Grid,
  Button,
  Paper,
  Typography,
  makeStyles,
  CssBaseline,
  Box,
  FormControl,
  Select,
} from "@material-ui/core";
import Error from "../Error";
import Loading from "../modales/Loading";
import { globales, mensajeglobales } from "../../helpers/Confi";
import swal from "sweetalert";
import { Alert, AlertTitle } from "@material-ui/lab";
import { isMobile } from "react-device-detect";
import { DecodificanString } from "../../helpers/Codifican";

const useStyles = makeStyles((theme) => ({
  paper: {
    margin: theme.spacing(5, 1),
    display: "flex",
    flexDirection: "column",
    alignitems: "center",
  },
  form: {
    width: "90%", // Fix IE 11 issue.
    marginTop: theme.spacing(0),
  },
}));

const VerificacionTest = () => {
  const [OpenLoading, setOpenLoading] = useState(false);

  const [error, setError] = useState(false);

  const [dvok, setMidv] = useState(""); // dv ok contiene el dv calculado

  const { SerieCedulaNatu, DataTipoContracto, DataSaldo } =
    useContext(UserContext);

  const parametros = globales(); //  parametros globales:
  const MSG = mensajeglobales(); // mensaje globales;

  // estado busqueda del formulario
  const [busqueda, guardarBusqueda] = useState({
    rut: "",
    // idCliente: 7, // este despues tengo que sacarlo
    // idContrato: 5, // este despues tengo que sacarlo
    banco: "",
    ctacte: "",
    nrodoc: "",
    monto: "",
    serieRUT: "",
  });

  const [bancos, setBanco] = useState([
    {
      Id: 0,
      Nombre: "",
      Activo: false,
    },
  ]);

  const { rut, banco, ctacte, nrodoc, monto, serieRUT } = busqueda;

  const handleChange = (e) => {
    guardarBusqueda({
      ...busqueda,
      [e.target.name]: e.target.value,
    });
    setBanco({
      ...bancos,
      [e.target.name]: e.target.value,
    });
  };

  const classes = useStyles();

  const history = useHistory();
  const userContext = useContext(UserContext);
  // info de la api de verificacion onp
  const { DataOnp } = useContext(UserContext);
  //info de la api de bancos
  const { DataBanco } = useContext(UserContext);

  const id = DecodificanString(JSON.parse(localStorage.getItem("id")));
  const login = DecodificanString(JSON.parse(localStorage.getItem("login")));
  const clientId = localStorage.getItem("clientId");
  const ClienteIdd = DecodificanString(
    JSON.parse(localStorage.getItem("clientId"))
  );
  const ContratoId = DecodificanString(
    JSON.parse(localStorage.getItem("contractId"))
  );

  const ValidarContraOnp = () => {
    userContext.getContractVerifOnp(id, login, ClienteIdd); //obten los datos que solicite en el formulario   // que se ejecute
  };

  React.useEffect(() => {
    userContext.getBanco();
    StateSaldoPrepago(ClienteIdd, ContratoId);
  }, []);

  React.useMemo(() => {
    ValidarContraOnp(id, login, ClienteIdd);
  }, []);

  const StateSaldoPrepago = (ClienteIdd, ContratoId) => {
    userContext.getTipoContracto(ClienteIdd, ContratoId);
  };

  const expreg = new RegExp("[0-9]+");

  const handleSubmit = (e) => {
    e.preventDefault();

    setOpenLoading(true);

    if (ctacte == "" || ctacte == 0 || ctacte == "00") {
      swal({
        title: "Atención",
        text: "El Nro. Cuenta es invalida. (INTENTE DE NUEVO)",
        icon: "info",
        button: "OK",
      });

      setOpenLoading(false);
      return;
    } else if (nrodoc.length == 0 || nrodoc == 0 || nrodoc == "00") {
      swal({
        title: "Atención",
        text: "Nro. Documento invalido. (INTENTE DE NUEVO)",
        icon: "info",
        button: "OK",
      });
      setOpenLoading(false);
      return;
    } else if (monto == "" || monto == 0 || monto == "00") {
      swal({
        title: "Atención",
        text: "El Monto ingresado no es valido. (INTENTE DE NUEVO)",
        icon: "info",
        button: "OK",
      });
      setOpenLoading(false);
      return;
    } else if (banco == 0 || banco == undefined) {
      swal({
        title: "Atención",
        text: "Debes de Seleccionar el tipo de banco (TIPO BANCO)",
        icon: "info",
        button: "OK",
      });
      setOpenLoading(false);
      return;
    } else {
      //validacion
      if (localStorage.getItem("ContratoVerifOnp")) {
        //userContext.getForm(busqueda) ESTABA DE MAS
        userContext.getDetalleOnp(busqueda);

        //  console.log('el usuario tiene los permisos para consultar!');

        if (
          rut.trim() === "" ||
          !expreg.test(rut) ||
          midv.trim() === "" ||
          banco.trim() === "" ||
          ctacte.trim() === "" ||
          !expreg.test(ctacte) ||
          nrodoc.trim() === "" ||
          !expreg.test(nrodoc) ||
          monto.trim() === "" ||
          !expreg.test(monto)
        ) {
          setTimeout(() => {
            setOpenLoading(false);
            setError(true);
          }, 4000);
          //limpiar campos
          e.target.reset();
        } else {
          setTimeout(() => {
            setOpenLoading(false);
            setError(false);
            setMidv(midv);
            //limpiar campos
            e.target.reset();
            history.push(parametros.rutaServidor + "verificacioncheque-result");
          }, 8000);
        }
      } else {
        const variable = JSON.parse(localStorage.getItem("ContratoVerifOnp"));
        // console.log(variable);
        // aqui debo mostrar el mensaje que viene de la api
        history.push(parametros.rutaServidor);
        swal({
          title: "Atención",
          text: MSG.MSG_NO_TIENE_PRODUCTO_ASOCIADO,
          icon: "info",
        });
        // console.log('El cliente no esta autorizado a realizar consultas de verificacion y onp');
      }
    }
  };

  //calculo de digito verificador
  const { calcularDv } = require("validar-rut");
  const midv = calcularDv(rut);

  return (
    <div style={{ display: 'flex', alignContent: "center", justifyContent: "center", width: "100%" }}>

      { OpenLoading ? <Loading /> : null }


      { DataTipoContracto != null || DataSaldo != null ?

           DataTipoContracto.IsPrepago && DataSaldo.Saldo === 0 ? (
            <Alert severity="warning">
              <AlertTitle>
                Atención su plan es: ({DataTipoContracto.Nombre})
              </AlertTitle>
              Pero no dispone de saldo para efectuar consulta —{" "}
              <strong>CONSULTE A SOPORTE</strong>{" "}
              <Button
                variant="outlined"
                color="primary"
                onClick={() => history.push("/viewsaldo")}
              >
                VER CONSUMO
              </Button>
            </Alert>
          ) : (
          <Box
              my={6}
              style={{ textAlign: "center"}}>
            <Grid
              item
              container
              xs={12}
              sm={12}
              md={12}
              xl={6}
              lg={6}
              component={Paper}
              elevation={3}
            >
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                xl={12}
                justifycontent="center"
                alignitems="center"
              >
                {isMobile ? (
                  <>
                    <Grid item xs={12} sm={12} md={12} xl={12} lg={12}>
                      <Box
                        my={4}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <Button
                          variant="outlined"
                          color="primary"
                          onClick={() => history.push("MenuMobile")}
                          style={{ alignitems: "center", paddingTop: "5px" }}
                        >
                          Menú Principal
                        </Button>
                      </Box>
                    </Grid>
                  </>
                ) : (
                  ""
                )}
                <Typography
                  component="h1"
                  variant="h4"
                  style={{ textAlign: "center", paddingTop: "5px" }}
                  className={classes.paper}
                >
                  {" "}
                  {/*el component es para quelo tome como un h1 */}
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <img
                      src={
                        process.env.PUBLIC_URL + "/static/imagen/VOdenopago.png"
                      }
                      width="100px"
                      height="100px"
                      alt="Logo pch.cl"
                      title="logo portal cheque"
                    />
                  </div>
                  Verificación de Cheques y ONP
                </Typography>
              </Grid>

              <Grid
                item
                container
                xs={12}
                sm={12}
                md={12}
                xl={12}
                lg={12}
                justify="space-around"
                alignitems="center"
              >
                <form
                  className={classes.form}
                  onSubmit={handleSubmit}
                  autoComplete="off"
                >
                  {error ? (
                    <Error mensaje="Debe completar todos los campos correctamente" />
                  ) : null}
                  <Grid
                    container
                    justify="flex-start"
                    alignitems="flex-start"
                    spacing={2}
                  >
                    <Grid item xs={12} sm={12} xl={6} md={6} lg={6}>
                      <NumberFormat
                        fullWidth
                        customInput={TextField}
                        //format="########"
                        autoFocus
                        label="N° Rut"
                        margin="normal"
                        name="rut"
                        value={rut}
                        id="rut"
                        variant="outlined"
                        onKeyDown={() => {
                          userContext.calculoserie(rut);
                        }}
                        required={true}
                        inputProps={{ maxLength: 8 }}
                        onChange={handleChange}
                      />
                    </Grid>
                    <Grid item xs={12} sm={12} md={2} xl={2} lg={2}>
                      <TextField
                        fullWidth
                        label=""
                        margin="normal"
                        id="dv"
                        name="midv" // aqui tengo que llevar el dv al informe!!! solo eso me falta!!!!!! pd(lo lleve con un estado :D)
                        value={midv}
                        variant="outlined"
                        disabled={true}
                        onChange={handleChange}
                      />
                    </Grid>

                    {!SerieCedulaNatu ? (
                      <Grid item xs={12} sm={12} xl={4} md={4} lg={4}>
                        <TextField
                          fullWidth
                          label="Serie Cedula"
                          margin="normal"
                          name="serieRUT"
                          value={serieRUT}
                          inputProps={{ maxLength: 10 }}
                          variant="outlined"
                          onChange={handleChange}
                        />
                      </Grid>
                    ) : (
                      ""
                    )}
                    <Grid item xs={12} sm={12} xl={6} md={6} lg={6}>
                      <NumberFormat
                        fullWidth
                        customInput={TextField}
                        // format="###########"
                        label="Cuenta Corriente"
                        margin="normal"
                        name="ctacte"
                        value={ctacte}
                        variant="outlined"
                        required={true}
                        inputProps={{ maxLength: 11 }}
                        onChange={handleChange}
                      />
                    </Grid>
                    <Grid item xs={12} sm={12} xl={6} md={6} lg={6}>
                      <NumberFormat
                        fullWidth
                        customInput={TextField}
                        //format="###########"
                        label="N° Documento"
                        margin="normal"
                        name="nrodoc"
                        value={nrodoc}
                        variant="outlined"
                        required={true}
                        inputProps={{ maxLength: 7 }}
                        onChange={handleChange}
                      />
                    </Grid>
                    <Grid item xs={12} sm={12} xl={6} md={6} lg={6}>
                      <NumberFormat
                        fullWidth
                        customInput={TextField}
                        //format="############"
                        label="Monto"
                        margin="normal"
                        name="monto"
                        value={monto}
                        variant="outlined"
                        required={true}
                        inputProps={{ maxLength: 8 }}
                        onChange={handleChange}
                      />
                    </Grid>
                    <Grid item xs={12} sm={12} xl={6} md={6} lg={6}>
                     
                      <FormControl variant="outlined" fullWidth margin="normal">
                        <Select
                          native
                          name="banco"
                          value={banco}
                          onChange={handleChange}
                          required={true}
                        >
                          <option value="0">--Seleccione Banco--</option>
                          {DataBanco.map((item) => (
                            <option value={item.Id} key={item.Nombre}>
                              {" "}
                              {item.Id} - {item.Nombre}{" "}
                            </option>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={12} xl={12} md={12} lg={12}>
                      <Box my={2}>
                        <Button
                          color="secondary"
                          fullWidth
                          size="large"
                          type="submit"
                          variant="outlined"
                        >
                          Consultar
                        </Button>
                      </Box>
                    </Grid>
                  </Grid>
                </form>
              </Grid>
            </Grid>
            </Box>
          )
        
       : '' }
    </div>
  );
};
export default VerificacionTest;
